module.exports = __webpack_public_path__ + "img/13csm_Ersa-Wave-01-900x600_a7372baadd.157c7d04.jpg";